import { TypedUseSelectorHook, useSelector } from "react-redux";
import { RootState } from "store/appStore";

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
